import {
    SET_COMPANY_CALLS_VIEW,
    SET_PAGINATION_END_BEFORE,
    SET_PAGINATION_START_AFTER,
    SET_PAGINATION_STEP,
    SET_SELECTED_EMPLOYEE
} from "./types";

export const setSelectedEmployee = (id, firstN, lastN) => {
    return{
        type: SET_SELECTED_EMPLOYEE,
        payload: {
            id,
            firstN,
            lastN,
        }
    }
}

export const setCompanyCallsView = (view) => {
    return{
        type: SET_COMPANY_CALLS_VIEW,
        payload: {
            view
        }
    }
}

export const setPaginationStartAfter = (paginationStartAfter) => {
    return{
        type: SET_PAGINATION_START_AFTER,
        payload: {
            paginationStartAfter,
        }
    }
}

export const setPaginationSteps = (paginationSteps) => {
    return{
        type: SET_PAGINATION_STEP,
        payload: {
            paginationSteps,
        }
    }
}
